import React from 'react'
import { Container, Stack, Text, Icon, Button } from '@popety-io/ui'
import { PublicLayout } from '../components/PublicLayout'

const NotFoundPage: React.FC = () => {
  return (
    <PublicLayout>
      <Container>
        <Stack
          align="center"
          justify="center"
          spacing="lg"
          style={{ minHeight: '60vh' }}
        >
          <Icon name="search" size="xl" color="secondary" />
          <Stack align="center" spacing="sm">
            <Text variant="h2" weight="bold">
              Page Not Found
            </Text>
            <Text variant="body1" color="secondary" align="center">
              The page you're looking for doesn't exist or the link may be
              invalid.
            </Text>
          </Stack>
          <Button
            variant="primary"
            onClick={() => (window.location.href = '/')}
          >
            Go to Homepage
          </Button>
        </Stack>
      </Container>
    </PublicLayout>
  )
}

export default NotFoundPage
